import mixpanel from "mixpanel-browser";
import { useInfluEarningWallet } from "../State/context";
import { FriendCard } from "./components";
import { VscGlobe } from "react-icons/vsc";
import { useAuth } from "../../../../../Providers/Auth";
import { useToast } from "../../../../../shadcnComponents/ui/use-toast";
import { MdContentCopy, MdOpenInNew } from "react-icons/md";
import { LinkButton } from "../../BoostVisibility/BoostVisibility";

export function ReferralEarning() {
  const authState = useAuth();
  const { toast } = useToast();
  const { referrals, handleGetReward } = useInfluEarningWallet();
  return (
    <div className="overflow-x-auto">
      {referrals?.length > 0 ? (
        // grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4
        <div className="grid grid-cols-2 items-center sm:flex sm:flex-wrap gap-4 justify-center md:justify-start">
          {referrals?.map((person, i) => (
            <FriendCard
              key={i}
              index={i}
              name={person?.name}
              profileImage={person?.profileImage}
              prize={person?.rewardAmount}
              onPrizeRevealed={() => {
                handleGetReward(person?._id, i);
                mixpanel.track("Claimed Referral Reward", {
                  referralId: person?._id,
                });
              }}
              isClaimed={person?.isClaimed}
            />
          ))}
        </div>
      ) : (
        <div className="flex rounded-[6px] border-[1px] border-dashed border-[#262626]">
          <div className="w-full p-4 flex flex-col items-center justify-center text-center">
            <div className="flex flex-col gap-[4px]">
              <div className="text-[14px] font-semibold text-white/90">
                No referral earnings, yet
              </div>
              <div className="text-[#A6A6A6] text-[12px] leading-[20px]">
                Invite your friends to join us using your unique referral code
                and earn referral rewards!
              </div>
            </div>
            <div className="w-fit flex justify-center items-center rounded-[100px] border-[1px] border-[solid] border-[#A3A3A3] mt-5 mb-3">
              <div className="flex px-[8px] py-[6px] justify-start items-center gap-[15px]">
                <VscGlobe size={18} color="#757575" />
                <span className="text-[#A3A3A3] text-[12px] font-normal leading-[20px] line-clamp-1">
                  {window.location.host}/influencer/?refer=
                  {authState?.loggedUser?.referralCode}
                </span>
              </div>
              <button
                className="hover:bg-[#232323] hover:rounded-full px-[8px] py-[6px]"
                onClick={(e) => {
                  e.stopPropagation();
                  mixpanel.track("Copied Referral Link");
                  navigator.clipboard.writeText(
                    `${window.location.protocol}//${window.location.host}/influencer/?refer=${authState?.loggedUser?.referralCode}`
                  );

                  toast({
                    title: "Referral Link Copied",
                  });
                }}
              >
                <MdContentCopy size={18} color="#757575" />
              </button>
            </div>
            <div className="flex gap-2 flex-wrap justify-center items-center">
              <LinkButton
                onClick={() => {
                  mixpanel.track(
                    "Clicked on share on whatsapp - Referral link"
                  );
                  window.open(
                    `https://api.whatsapp.com/send?text=${`${window.location.protocol}//${window.location.host}/influencer/?refer=${authState?.loggedUser?.referralCode}`}`,
                    "_blank"
                  );
                }}
              >
                Share on WhatsApp
                <MdOpenInNew size={14} />
              </LinkButton>
              <LinkButton
                onClick={() => {
                  mixpanel.track(
                    "Clicked on share on linkedin - referral link"
                  );
                  navigator.clipboard.writeText(
                    `${window.location.protocol}//${window.location.host}/influencer/?refer=${authState?.loggedUser?.referralCode}`
                  );

                  toast({
                    title: "Referral Link Copied",
                  });

                  window.open(
                    `https://www.linkedin.com/shareArticle`,
                    "_blank"
                  );
                }}
              >
                Share on LinkedIn
                <MdOpenInNew size={14} />
              </LinkButton>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
